<template>
<el-dialog v-dialogDrag title="问题详情"
    width="85vw" top="10vh"
    :visible.sync="showDetail" :close-on-click-modal="false" 
    :close-on-press-escape="false"
    @close='closeDialog'>
    <div class="issueStyleDetail">
      <div class="detailTop">
        <div class="detailTopLeft" :key='formKey'>
          <div class="leftBigImg">
            <el-image
              :src="questionImgListUrl(cutImageList[currentIndex])"
              style="width: 100%; height: 100%"
              fit="cover"
            >
              <div slot="placeholder" class="image-slot"> 加载中<span class="dot">...</span> </div>
            </el-image>
          </div>
          <div class="rightSmallImg">
            <div
              v-for="(item, i) in cutImageList"
              :key="i"
              class="bottomImg"
              :class="{ active: currentIndex == i, }"
              @click="selectIindex(i)"
            >
              <el-image
                :src="questionImgListUrl(item)"
                style="width: 100%; height:100%; border: 1px solid #cfd1d4"
                fit="cover"
              >
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>
              <img class="bigscreen" :src="bigImage" @click="showBigImage(item)">
            </div>
          </div>
        </div>
        <el-image
          ref="imagePreview"
          style="height: 0px; width: 0px; overflow: hidden; opacity: 1"
          :src="previewSrc"
          :z-index="3000"
          :preview-src-list="previewSrcList"
        />
        <div class="detailTopRight">
          <el-radio-group size="small" v-model="detailType" @change="navType">
            <el-radio-button label="问题详情"></el-radio-button>
            <el-radio-button label="活动记录"></el-radio-button>
          </el-radio-group>
          <div class="detailContent">
            <navdetailVue ref="navdetailVue" @update="update" v-if="detailType == '问题详情'" :checkContent='rowData.checkContent'/>
            <el-button @click="openEditQue" v-if="detailType == '问题详情'&&!editDetail" class="editButton" size="mini" type="primary">编辑</el-button >
            <div v-if="detailType == '问题详情'&&editDetail" class="editFoot">
              <el-button  size="mini" type="primary" plain class="editFootButton" @click='closeEdit'>取 消</el-button>
              <el-button  size="mini" type="primary" class="editFootButton" @click="sureEdit">保 存</el-button>
            </div>
            <el-button @click="openPreviewing" v-if="detailType == '问题详情'" size="mini" type="primary" plain class="editButton">打开问题文件</el-button >
            <nvalineVue ref="nvalineVue" :rowData="rowData" v-if="detailType == '活动记录'"/>
          </div>
        </div>
      </div>
      <div class="detailBottom">
        <div class="detailBottomLeft" :key='formKey'>
          <span style="color:red">*</span>
          <span class="detailBottomTitle">问题描述</span>
          <el-input v-model="rowData.checkContent" type="textarea" rows="4" show-word-limit maxlength="200" :readonly="detailType !== '问题详情'||!editDetail" ></el-input>
        </div>
        <div class="detailBottomLeft">
          <navreplyVue ref="navreplyVue"/>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" plain size="small" v-if="!editDetail" @click="previousPage">上一页</el-button >
      <el-button type="primary" plain size="small" v-if="!editDetail" @click="nextPage">下一页</el-button>
      <el-button type="primary"  size="small" @click="saveComment">发表回复</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { noLabelFilePreview } from "@/CommonDP/utils/docPublic";
import navdetailVue from "./navdetail.vue";
import navreplyVue from  "./navreply.vue";
import nvalineVue from "./nvaline.vue";
import { questionImgUrl1 } from "@/utils";
import requestIssueMg from "@/CommonDP/service/question-service";
import { mapState } from "vuex";
// import { number } from 'echarts/lib/export';
export default {
  components:{navdetailVue,navreplyVue,nvalineVue},
  data(){
    return{
      detailType:'问题详情',
      showDetail:false,
      rowData:{},
      editDetail:false,
      currentIndex: 0,
      bigImage: require('../../../assets/bigImage.png'),
      previewSrc: null,
      previewSrcList: [],
      tableData:[],
      formKey:0
    }
  },
  computed: {
    ...mapState({
      userId: state => state.user.userId
    }),
    cutImageList () {
      if (this.rowData.autoScreenshotMd5) {
        return [this.rowData.autoScreenshotMd5, ...this.rowData.picMd5List]
      } else {
        if(this.rowData.picMd5List)return [...this.rowData.picMd5List]
        else return []
      }
    },
  },
  methods:{
    showBigImage (md5) {
      this.previewSrc = questionImgUrl1(md5)
      this.previewSrcList = [this.previewSrc]
      this.$nextTick(() => {
        this.$refs.imagePreview.clickHandler()
      })
    },
    openDetail(row,data){
      this.showDetail=true
      this.detailType='问题详情'
      this.rowData=row
      this.tableData=data
      this.$nextTick(()=>{
        this.navType()
      })
    },
    navType(){
      this.editDetail=false
      if(this.detailType == "问题详情"){
        this.$refs.navdetailVue.getDetailInit(this.rowData.questionId,this.rowData.prjId,this.rowData.fileId)
        this.$refs.navreplyVue.showCommentInfo(3, this.rowData.prjId, 1, this.rowData.questionId, this.rowData.questionId, "" );
        this.$refs.navreplyVue.userListShowFlag=false
      }else{
        this.$refs.nvalineVue.getTimeLine()
      }
    },
    update(){
      this.$emit("update")
    },
    openPreviewing(){
      this.$store.dispatch("setModelquestionData",this.rowData)
      const {fileList,prjId,source,fileTypeInt:fileType,questionId}=this.rowData;
      let row=""
      if(fileList.length >1){
         row={
          folderId:fileList.map(ele=>ele.fileId).join(','),
          folderName:fileList.map(ele=>ele.fileName).join(','),
          fileVersion:fileList.map(ele=>ele.fileVersion).join(','),
          prjId,
          fileType:Number(fileType),
          status:'2'
        };
      }else{
        row={
          folderId:fileList[0].fileId,
          folderName:fileList[0].fileName,
          fileVersion:fileList[0].fileVersion,
          prjId,
          fileType:Number(fileType),
          status:'2'
        };
      }
      noLabelFilePreview(row, prjId, '', 'ct','',questionId);
    },
    openDeleteQue(){
      this.$confirm("确定删除该条问题？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(async() => {
        const ids=[this.rowData.questionId]
        const res = await requestIssueMg.DrawingQuestionDelete(ids)
        if(res.result == "0"){
          this.$message.success("删除成功")
          this.$emit("closeRight")
          this.$emit("update")
        }
      }).catch(() => {});
    },
    openEditQue(){
      this.editDetail=true
      this.$refs.navdetailVue.openEdit()
      // this.$refs.navdetailVue.isRead=false
    },
    closeEdit(){
      this.editDetail=false
      this.$refs.navdetailVue.closeEdit()
    },
    async sureEdit(){
      if(!this.rowData.checkContent)return this.$message.warning('请填写问题描述')
      await this.$refs.navdetailVue.sureEdit()
      this.editDetail=false
    },
    closeDialog(){
      this.$emit("refresh")
    },
    closePane(){
      this.$emit("closeRight")
    },
    async saveComment(){
      await this.$refs.navreplyVue.saveComment()
      if(this.detailType == '活动记录'){
        this.$nextTick(()=>{
          his.$refs.nvalineVue.getTimeLine()
        })
      }
    },
    questionImgListUrl (fileMD5) {
      if (!fileMD5) return
      return questionImgUrl1(fileMD5)
    },
    selectIindex (i) {
      this.currentIndex = i
    },
    previousPage(){
      const index = this.tableData.findIndex(item => item.questionId === this.rowData.questionId);
      if(index===0)return this.$message.info('这已经是当前第一条问题')
      else{
        this.rowData=this.tableData[index-1]
        this.navType()
      }
    },
    nextPage(){
      const index = this.tableData.findIndex(item => item.questionId === this.rowData.questionId);
      if(index===this.tableData?.length-1)return this.$message.info('这已经是当前最后一条问题')
      else{
        this.rowData=this.tableData[index+1]
        this.navType()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.issueStyleDetail{
  width: 100%;
  height: 70vh;
  overflow: hidden;
  .detailTopRight{
    padding: 0 10px;
    text-align: center;
    width: 20%;
    height: 100%;
    /deep/.el-radio-button__inner{
      padding: 9px 46px;
    }
  }
  .detailContent{
    height: calc(100% - 32px);
    width: 100%;
  }
}
/deep/.el-dialog__title{
  font-weight: 600;
}
.detailTop{
  display: flex;
  height:80%;
  width: 100%;
}
.detailTopLeft{
  width: 80%;
  height: 100%;
  border-right: 1px solid #E8EBEF;
  display: flex;
  .leftBigImg {
    height: 100%;
    width: 80%;
  }
  .rightSmallImg {
    height: 100%;
    width: 20%;
    padding-left: 10px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    > div:nth-last-child(1) {
      margin-bottom: 0px;
    }
    > div.active {
      border: 1px solid #4777e7;
    }
    .bottomImg {
      position: relative;
      width: 100%;
      height:25%;
      display: flex;
      margin-bottom: 5px;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      &:hover {
        border-color: #4777e7;
        cursor: pointer;
      }
      .defaultline {
        background: #d4d9ec;
        border-radius: 3px;
        width: 80%;
        margin-bottom: 6px;
        height: 2px;
      }
      .lineActive {
        background: #fa8d19;
      }
    }
    .bigscreen {
      position: absolute;
      bottom: 5px;
      right: 10px;
    }
  }
}
.editButton ,.editFootButton{
  color: #fff;
  margin-bottom: 5px;
  padding: 5px;
  cursor: pointer;
}
.editButton{
  background-color:#4777e7;
  width: 100%;
  margin-left: 0px !important;
}
.editFootButton{
  width: 49%;
  margin-bottom: 5px;
}
.editFoot{
  display: flex;
  justify-content: space-between;
}
.detailBottom{
  display: flex;
  justify-content: space-between;
  // padding: 0 10px;
  .detailBottomLeft{
    width: 49.5%;
    .detailBottomTitle{
      font-size: 14px;
      line-height: 24px;
      margin-bottom: 5px;
      font-weight: 600;
    }
    /deep/.el-textarea__inner{
      color: red;
    }
  }
}
</style>